export const state = {
    token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    meteoToken: localStorage.getItem('meteoToken') ? localStorage.getItem('meteoToken') : null,
    userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : null,
    type: localStorage.getItem('type') ? localStorage.getItem('type') : null,
    username: localStorage.getItem('username') ? localStorage.getItem('username') : null,
    ip: localStorage.getItem('ip') ? localStorage.getItem('ip') : null,
    userType: 0,
}

export const mutations = {
    changeLogin(state, token) {
        if (token) {
            state.token = token;
            localStorage.setItem('token', token);
        }
    },
    changeMeteoToken(state, token) {
        if (token) {
            state.meteoToken = token;
            localStorage.setItem('meteoToken', token);
        }
    },
    changeAdsbUrl(state, { userId, type }) {
        if (userId) {
            state.userId = userId;

            state.type = type;
            localStorage.setItem('userId', userId);
            localStorage.setItem('type', type);
        }
    },
    changeInfo(state, username) {
        state.username = username;
        localStorage.setItem('username', username);
    },
    changeIp(state, ip) {
        state.ip = ip;
        localStorage.setItem('ip', ip);
    },
    changeUserType(state, userType) {
        console.log(userType);
        state.userType = userType;
    }
}

export const getters = {
    user(state) {
        return state.token
    },
    meteoToken(state) {
        return state.meteoToken
    },
    userId(state) {
        return state.userId
    },
    type(state) {
        return state.type
    },
    username(state) {
        return state.username
    },
    ip(state) {
        return state.ip
    },
    userType(state) {
        return state.userType
    },
}